import { lazy, type ReactNode, Suspense } from "react";
import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";

import { useShowMaintenancePage } from "@/hooks";
import { useInitMultiLingual, useI18nReady } from "shared/hooks";
import { languageVar } from "@/variables/globalVar";

import { Header } from "@/components/header";

const MaintenancePage = lazy(() => import("@/pages/MaintenancePage"));
const API_BASE_URL = import.meta.env.VITE_REACT_APP_BACKEND_ENDPOINT;

export interface LayoutProps {
  children: ReactNode;
  useMyLotLogo?: boolean;
}

export function Layout({ children, useMyLotLogo }: LayoutProps) {
  const showMaintenancePage = useShowMaintenancePage();
  const language = useAtomValue(languageVar);
  const isI18nReady = useI18nReady();

  const location = useLocation();

  // Initialize i18n for all routes (including login/signup)
  useInitMultiLingual(language, API_BASE_URL);

  // Force re-render of entire layout when language or i18n state changes
  const layoutKey = `${language}-${isI18nReady ? "ready" : "loading"}`;

  if (
    showMaintenancePage &&
    !["/login", "/login/"].includes(location.pathname)
  ) {
    return (
      <Suspense>
        <MaintenancePage />
      </Suspense>
    );
  }

  return (
    <div key={layoutKey} className="flex h-dvh w-full flex-col">
      <Header useMyLotLogo={useMyLotLogo} />

      <div className="flex w-full grow flex-col overflow-hidden">
        {children}
      </div>
    </div>
  );
}

export default Layout;
